import { FC, ReactNode } from "react"

import { InstallButton } from "./InstallButton"
import { ShareButton } from "./ShareButton"
import { QRCodeButton } from "./QRCodeButton"
// import { logEvent } from "../utils/logEvent"

export const AppHeader: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <div className="bg-form-light w-full px-3 h-16 fixed">
      <div className="flex h-full w-full lg:max-w-5xl mx-auto items-center justify-between pt-1 relative">
        <a
          href="https://coherent.global/"
          target="_blank"
          rel="noreferrer"
          // onClick={() => logEvent("DemoAppLogoClick")}
        >
          <img src="/coherent-logo.png" alt="Coherent" className="h-8" />
        </a>

        {children}

        <div className="flex space-x-3">
          <QRCodeButton />
          <ShareButton />
          <div className="install-button-container">
            <InstallButton />
          </div>
        </div>
      </div>
    </div>
  )
}

